import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,

  props: ['data', 'stacked'],

  watch: {
    data: function () {
      this.showChart();
    }
  },

  mounted() {
    this.showChart()
  },

  methods: {
    showChart() {
      this.renderChart(this.data, {
        responsive: true, maintainAspectRatio: false,
        scales: this.stacked ? {
          xAxes: [{
            stacked: true,
            categoryPercentage: 0.5,
            barPercentage: 1
          }],
          yAxes: [{
            stacked: true
          }]
        } : null
      })
    }
  }
}